export default "__VITE_ASSET__DmaU4Shy__"